import { gql } from 'graphql-request'

const getOrderedMentors = gql`
  query getOrderedMentors(
    $target: MentorsOrderedTarget
    $locale: [Locales!]
    $lang: [Locale!]
    $limit: Int
  ) {
    mentorsOrdereds(
      where: { target: $target, target_locale_contains_some: $locale }
    ) {
      mentors(locales: $lang, first: $limit) {
        id
        title: firstName
        shortDescription
        aboutMentor
        implantType
        gender
        location
        birthday
        speakingLanguages
        text {
          text
        }
      }
    }
  }
`
export default getOrderedMentors
